import React, { useState, useEffect } from 'react';

const OfflineBanner: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      // Hide banner after a short delay when coming back online
      setTimeout(() => setIsVisible(false), 2000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setIsVisible(true);
    };

    // Set initial state
    setIsOnline(navigator.onLine);
    if (!navigator.onLine) {
      setIsVisible(true);
    }

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className='fixed top-0 left-0 right-0 z-50 bg-yellow-500 text-yellow-900 px-4 py-2 text-center shadow-md'>
      <div className='flex items-center justify-center space-x-2'>
        <span className='text-lg'>📡</span>
        <span className='text-sm font-medium'>
          {isOnline
            ? "You're back online! Progress will sync automatically."
            : "You're offline—progress will sync when you're back."}
        </span>
        {!isOnline && (
          <button
            onClick={() => setIsVisible(false)}
            className='ml-2 text-yellow-800 hover:text-yellow-900'
            aria-label='Dismiss offline banner'
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default OfflineBanner;
